import * as angular from 'angular';

export class TriarcEnum {
  static getNames(anEnum: any): string[] {
    var enumNames: string[] = [];
    TriarcEnum.forEach(anEnum,(val, name) => {
      enumNames.push(name);
    });
    return enumNames;
  }

  static getEnumValue(anEnum: any, index: number) {
    var ordinals = TriarcEnum.getOrdinals(anEnum);
    return ordinals[index];
  }

  static getOrdinals(anEnum: any): number[]{
    var enumValues: number[] = [];
    TriarcEnum.forEach(anEnum, (val, name) => {
      enumValues.push(val);
    });
    return enumValues;
  }
  static forEach(anEnum: any, callback: (value: number, name: string) => void): void {
    for (var val in anEnum) {
      var name = anEnum[val];
      if (typeof (name) === "string") {
        callback(anEnum[name], name);
      }
    }
  }
}

export class Triarc {
  static generateGuid(): string {
    if(typeof (crypto) != 'undefined' && typeof (crypto.getRandomValues) != 'undefined') {
      // If we have a cryptographically secure PRNG, use that
      // http://stackoverflow.com/questions/6906916/collisions-when-generating-uuids-in-javascript
      var buf = new Uint16Array(8);
      crypto.getRandomValues(buf);
      var S4 = num => {
        var ret = num.toString(16);
        while (ret.length < 4) {
          ret = "0" + ret;
        }
        return ret;
      };
      return (S4(buf[0]) + S4(buf[1]) + "-" + S4(buf[2]) + "-" + S4(buf[3]) + "-" + S4(buf[4]) + "-" + S4(buf[5]) + S4(buf[6]) + S4(buf[7]));
    } else {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      })
    }
  }

  static hasValue(value: any): boolean {
    return value !== undefined && value !== null;
  }

  static hasNoValue(value: any): boolean {
    return !Triarc.hasValue(value);
  }
  static isTrue(value?: boolean): boolean {
    if (Triarc.hasNoValue(value)) return false;

    return value;
  }

  static getOrdinals(anEnum: any): number[] {
    return TriarcEnum.getOrdinals(anEnum);
  }

  static getEnumValue(anEnum: any, index: number) {
    return TriarcEnum.getEnumValue(anEnum, index);
  }

  static getNames(anEnum: any): string[] {
    return TriarcEnum.getNames(anEnum);
  }


  static arrayHasValues(array: any): boolean {
    return angular.isArray(array) && array.length > 0;
  }

  static strContains(str: string, value: string): boolean {
    return angular.isString(str) && str.indexOf(value) !== -1;
  }

  static randomNumber(start: number, end: number): number {
    return Math.floor(Math.random() * end) + start;
  }

  static strNotEmpty(str: string): boolean {
    return angular.isString(str) && str.length > 0;
  }

  static strIsEmpty(str: string): boolean {
    return !angular.isString(str) || str.length === 0;
  }

  private static FLOAT_REGEXP = /^(\-|\+)?\d+((\.|\,)\d+)?$/;

  static validFloat(value: any, greaterThan?: number): boolean {
    return Triarc.FLOAT_REGEXP.test(value) && (Triarc.hasValue(greaterThan) ? value > 0 : true);
  }

  static validNumber(value: number, greaterThan?: number): boolean {
    return angular.isNumber(value) && (Triarc.hasValue(greaterThan) ? value > 0 : true);
  }

  static getRandomChars(valueStr: string, numberOf: number): string {
    var returnValue = "";
    // cycle through n number of times and get random bytes from the contents of the file
    for (var i = 0; i < numberOf; i++) {
      var randomPosition = Triarc.randomNumber(0, valueStr.length);
      returnValue += valueStr.charAt(randomPosition);
    }
    return returnValue;
  }
}